function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   display: inline-block;\n   line-height: ", ";\n   white-space: nowrap;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
var TopNavMenuItem = styled.li(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.sizes.siteHeaderHeight;
});
export { TopNavMenuItem };